// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import type { MapStateToProps } from 'react-redux';

import EventContainer from './calendar.event-container.js';
import ResourceDescription from './calendar.event-resource-description.js';
import Discrepancies from './calendar.event-discrepancies.js';
import Inspections from './calendar.event-inspections';
import EditValueForm from './components/edit.value.form.js';

import { EVENT_RESOURCE, EVENT_CHECKIN } from '../calendar.consts.js';

type OwnProps = {||};

type MappedState = {|
  UI: UI,
  URL: URL
|};

type Props = {|
  ...OwnProps,
  ...MappedState
|};

type State = {||};

class EventResource extends React.Component<Props, State> {
  static footer = true;

  constructor(props: Props) {
    super(props);
    this.handleCheckInClick = this.handleCheckInClick.bind(this);

    this.state = {
      countersOptions: this.checkCounters(),
    }
  }

  state = {
    countersOptions: null,
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot: SS) {
    const counters = this.checkCounters();

    const isPropsUpdated = JSON.stringify(this.getCounterSource(this.props).counters)
      !== JSON.stringify(this.getCounterSource(prevProps).counters);

    if (isPropsUpdated) {
      this.setState({
        countersOptions: counters,
      });
    }
  }

  handleCheckInClick() {
    const {switchModals, URL} = this.props;
    const {eventParams, eventBreadcrumbs} = URL;

    return switchModals(
      EVENT_CHECKIN,
      {
        ...eventParams,
        action: EVENT_CHECKIN
      },
      eventBreadcrumbs.concat({
        ...eventParams,
        action: EVENT_CHECKIN
      })
    );
  }

  getCounterSource = (props) => {
    const {aircraft, event} = props;

    return parseInt(event.checkInEnable, 10) === 1 || parseInt(event.checkOutEnable, 10) === 1
        ? aircraft
        : event;
  }

  checkCounters = () => {
    const {countersOptions} = this.state;

    const counterSource = this.getCounterSource(this.props)

    if (counterSource && counterSource.counters) {
      let counters = {};

      counterSource.counters.forEach((counter) => {
        const {id, value, oldValue, diff} = counter;

        counters[id] = {
          isOldEdited: false,
          isNewEdited: false,
          oldValue: oldValue,
          value: value,
          diff: diff,
        };

        if (!diff && !oldValue) {
          counters[id] = {
            ...counters[id],
            oldValue: counters[id].value,
            value: undefined,
            diff: 0,
          }
        }
      });

      if (Object.keys(counters).length) {
        return counters;
      }
    }

    return countersOptions;
  }

  onEditValueFormChange = (id, paramName, event) => {
    const {countersOptions} = this.state;
    let newOptions = {...countersOptions};
    const counter = newOptions[id];

    counter[paramName] = event.target.value;

    if (counter.value && counter.oldValue) {
      counter.diff = (counter.value - counter.oldValue).toFixed(2);
    }

    this.setState({
      countersOptions: newOptions,
    })
  }

  onToggleEdit = (id, paramName, targetValue) => {
    const {countersOptions} = this.state;
    let newOptions = {...countersOptions};
    const counter = newOptions[id];

    if (targetValue && !counter[paramName]) {
      counter.safeValues = {
        [targetValue] : counter[targetValue]
      }
    } else if (counter[paramName] && counter.safeValues && counter.safeValues[targetValue]) {
      counter[targetValue] = counter.safeValues[targetValue];

      if (counter.value && counter.oldValue) {
        counter.diff = (counter.value - counter.oldValue).toFixed(2);
      }
    }

    counter[paramName] = !counter[paramName];

    this.setState({
      countersOptions: newOptions,
    })
  }

  onHobbsSubmit = async (id, paramName) => {
    const {event, aircraft} = this.props;
    const {countersOptions} = this.state;

    const counterSource =
      parseInt(event.checkInEnable, 10) === 1 || parseInt(event.checkOutEnable, 10) === 1
        ? aircraft
        : event;

    const currentCounter = counterSource.counters.find((counter) => counter.id === id);
    const counterState = countersOptions[id];

    delete currentCounter.safeValues;

    const body = {
      ...currentCounter,
      aircraftID: counterSource.aircraftID || counterSource.id,
      eventId: event.id,
      actionName: "day",
      _timezone: "America/Nome",
      _method: "ajax",
      oldValue: counterState.oldValue,
      value: counterState.value || counterState.oldValue
    };

    await this.updatingHobbs(body);
    this.onToggleEdit(id, paramName);
  }

  updatingHobbs = async (body) => {
    const {organization} = this.props;
    const url = `${window.serverData._uri}/org/${organization.unique}/hangars/saveCounter/`;

    const headers = {
      Accept: 'application/json',
      'Content-Type': 'text/plain;charset=UTF-8',
      api: 'ajax'
    };

    const response = await fetch(url, {
      method: 'post',
      mode: 'cors',
      headers,
      credentials: 'same-origin',
      cache: 'default',
      body: JSON.stringify(body),
    });

    let data = {};
    const text = await response.text();
    try {
      data = JSON.parse(text);
    } catch (e) {
      console.warn(url);
      console.error(e.message);
    }
    return data;
  }

  render() {
    const {event, aircraft, accessgroups, resources, UI, user} = this.props;
    const {countersOptions} = this.state;

    if (!aircraft || !aircraft.id) return null;
    if (!event || !event.id) return null;

    const isAircraft = resources[aircraft.resourceID].resourceTypeName === 'Aircraft';

    const counterSource =
      parseInt(event.checkInEnable, 10) === 1 || parseInt(event.checkOutEnable, 10) === 1
        ? aircraft
        : event;

    // TODO Remove after backend fix for duplicated hobbs
    let filteredCounters = counterSource.counters;
    if (counterSource.counters && counterSource.counters.length) {
      const ids = counterSource.counters.map(o => o.id);
      filteredCounters = counterSource.counters.filter(({id}, index) => !ids.includes(id, index + 1))
    }

    const userIsAPilot = event.pilotID === user.id;
    const meterView = userIsAPilot || accessgroups.meterView;
    const counterEdit = userIsAPilot || accessgroups.counterEdit;

    return (
      <EventContainer>
        <ResourceDescription />

        {filteredCounters && meterView ? (
          <div className="meters-inspections-wrap">
            <div className="meters">
              <h5 className="discrepancies-modal-heading">Meters Values</h5>
              <div className="table-meters-wrap">
                <table className="table table-sm table-meters">
                  <thead>
                    <tr>
                      <td>
                        <b>Name</b>
                      </td>
                      <td className="text-right">
                        <b>Start</b>
                      </td>
                      <td
                        className={
                          filteredCounters[0] && filteredCounters[0].oldValue
                            ? 'text-right'
                            : 'text-center text-muted'
                        }
                      >
                        <b>End</b>
                      </td>
                      <td
                        className={
                          filteredCounters[0] && filteredCounters[0].diff
                            ? 'text-right'
                            : 'text-center text-muted'
                        }
                      >
                        <b>Total</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCounters.length ? (
                      filteredCounters.map((counter, index) => {
                        const hobbsOn = counter.type === 'hobbs' && aircraft.enableHobbs === '1';
                        const tachometerOn =
                          counter.type === 'tachometer' && aircraft.enableTachometers === '1';
                        if ((!hobbsOn && !tachometerOn) || !countersOptions) return null;

                        const options = countersOptions[counter.id] || {};
                        const {isOldEdited, isNewEdited, oldValue, value, diff} = options;

                        return (
                          <tr key={`meters-${counter.id}-${index}`} className="middle">
                            <td>
                              <div className="meter-name">{counter.name}</div>
                            </td>
                            <td className="text-right" style={{ wordBreak: 'normal' }}>
                              {!isOldEdited && counterEdit && (<span>
                                {oldValue || value}&#8194;
                                <span
                                  className="link--ajax"
                                  onClick={() => this.onToggleEdit(counter.id, "isOldEdited", "oldValue")}
                                >
                                  Edit
                                </span>
                              </span>)}

                              {isOldEdited && (
                                <EditValueForm
                                 UI={UI}
                                 onChange={(event) => this.onEditValueFormChange(counter.id, "oldValue", event)}
                                 onClose={() => this.onToggleEdit(counter.id, "isOldEdited", "oldValue")}
                                 onSubmit={() => this.onHobbsSubmit(counter.id, "isOldEdited")}
                                 value={oldValue}
                                />
                              )}
                            </td>
                            <td
                              className={oldValue ? 'text-right' : 'text-center'}
                              style={{wordBreak: 'normal'}}
                            >
                              {!isNewEdited && (
                                value
                                  ? (<span>
                                      {value}&#8194;
                                      <span
                                        className="link--ajax"
                                        onClick={() => this.onToggleEdit(counter.id, "isNewEdited", "value")}
                                      >
                                        Edit
                                      </span>
                                    </span>)
                                  : <span>&mdash;</span>
                              )}
                              {isNewEdited && (
                                <EditValueForm
                                  UI={UI}
                                  onChange={(event) => this.onEditValueFormChange(counter.id, "value", event)}
                                  onClose={() => this.onToggleEdit(counter.id, "isNewEdited", "value")}
                                  onSubmit={() => this.onHobbsSubmit(counter.id, "isNewEdited")}
                                  value={value}
                                />
                              )}
                            </td>
                            <td
                              className={diff ? 'text-right' : 'text-center'}
                              style={{wordBreak: 'normal'}}
                            >
                              {diff ? diff : <span>&mdash;</span>}
                            </td>
                          </tr>
                        );
                      })
                    ) : aircraft.enableHobbs === '1' ? (
                      <tr>
                        <td>
                          <div className="meter-name">Hobbs</div>
                        </td>
                        <td className="text-right" style={{wordBreak: 'normal'}}>
                          {aircraft.hobbsValue}
                        </td>
                        <td className="text-right" style={{wordBreak: 'normal'}}>
                          <span>&mdash;</span>
                        </td>
                        <td className="text-center" style={{wordBreak: 'normal'}}>
                          <span>&mdash;</span>
                        </td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}

        <Inspections/>

        {isAircraft ? <Discrepancies switchModals={this.props.switchModals} /> : null}
        <input id={EVENT_RESOURCE} onClick={this.handleCheckInClick} style={{ display: 'none' }} />
      </EventContainer>
    );
  }
}

const mapStateToProps: MapStateToProps<ReduxState, OwnProps, MappedState> = state => ({
  URL: state.URL,
  UI: state.UI,
  accessgroups: state.accessgroups,
  event: state.event,
  aircraft: state.aircraft,
  organization: state.organization,
  resources: state.resources,
  user: state.user
});

export default connect(
  mapStateToProps,
  {}
)(EventResource);
